import React, { useEffect, useState } from 'react';
import { Grid, Box, TextField } from '@mui/material';
import DataTable from '../../common/DataTable';
import SectionCard from '../shared/SectionCard';
import KpiGrid from '../shared/KpiGrid';
import { CheckCircle, Cancel } from '@mui/icons-material';
import { adminDashboardService } from '../../../services/dashboard';
import ApplicationDrilldownDialog from './ApplicationDrilldownDialog';

const kpiItems = [
  { key: 'active', title: 'Active Applications', icon: <CheckCircle /> },
  { key: 'disabled', title: 'Disabled Applications', icon: <Cancel /> },
];

const columns = [
  { field: 'appName', headerName: 'Application', sortable: true },
  { field: 'businessName', headerName: 'Business', sortable: true },
  { field: 'users', headerName: 'Users', align: 'right', format: (v) => v?.toLocaleString(), sortable: true },
  { field: 'authPerDay', headerName: 'Auth/Day', align: 'right', format: (v) => v?.toLocaleString(), sortable: true },
  { field: 'successRate', headerName: 'Success Rate', align: 'right', format: (v) => `${v}%`, sortable: true },
  { field: 'status', headerName: 'Status', type: 'status', statusColors: { ACTIVE: 'success', DISABLED: 'warning', DELETED: 'error' }, sortable: true },
];

const ApplicationsSection = ({ reloadKey }) => {
  const [overview, setOverview] = useState(null);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedAppId, setSelectedAppId] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    adminDashboardService
      .getApplications(page + 1, rowsPerPage, search)
      .then((res) => {
        setOverview(res.data.overview);
        setRows(res.data.applications.map((a) => ({ ...a, id: a.applicationId })));
        setTotal(res.total);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [page, rowsPerPage, search, reloadKey]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <KpiGrid items={kpiItems} data={overview} loading={loading && !overview} error={overview ? null : error} />
      </Grid>
      <Grid item xs={12}>
        <SectionCard
          title="Applications"
          controls={
            <TextField
              size="small"
              placeholder="Search app or business..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(0);
              }}
            />
          }
          loading={loading}
          error={error}
          isEmpty={!loading && !error && rows.length === 0}
          minHeight={380}
        >
          <Box sx={{ height: 380, display: 'flex', flexDirection: 'column' }}>
            <DataTable
              columns={columns}
              data={rows}
              page={page}
              rowsPerPage={rowsPerPage}
              totalRows={total}
              onPageChange={setPage}
              onRowsPerPageChange={(n) => {
                setRowsPerPage(n);
                setPage(0);
              }}
              onView={(row) => setSelectedAppId(row.applicationId)}
            />
          </Box>
        </SectionCard>
      </Grid>
      <ApplicationDrilldownDialog appId={selectedAppId} onClose={() => setSelectedAppId(null)} />
    </Grid>
  );
};

export default ApplicationsSection;
